import React from 'react'

function ErrorPage() {
  return (
    <div>ERROR 404: PAGE NOT FOUND</div>
  )
}

export default ErrorPage